export default function navigateWithTransition(navigate, to, options) {
  if (typeof document.startViewTransition === "function") {
    document.startViewTransition(() => navigate(to, options));
  } else {
    navigate(to, options);
  }
}
